/**
 * Tarih aralıkları İstanbul günüyle (Türkiye 2016'dan beri sabit UTC+3): seçilen gün
 * 00:00:00.000 ile 23:59:59.999 arası an olarak gönderilir. Gösterim tarayıcının saat
 * diliminden bağımsız olarak İstanbul günüdür.
 */
const OFFSET = '+03:00';
const OFFSET_MS = 3 * 3_600_000;
const DAY_MS = 86_400_000;

export function istanbulDayRange(fromDay: string, toDay: string): { from: string; to: string } {
  return {
    from: new Date(`${fromDay}T00:00:00.000${OFFSET}`).toISOString(),
    to: new Date(`${toDay}T23:59:59.999${OFFSET}`).toISOString(),
  };
}

/** Bitiş günü başlangıçtan önceyse uyarı metni; aynı gün geçerlidir. Boş ya da eksik gün ters sayılmaz. */
export function dayRangeError(fromDay: string, toDay: string): string | null {
  return Date.parse(toDay) < Date.parse(fromDay) ? 'Bitiş, başlangıçtan önce olamaz.' : null;
}

/** Bugünün (± gün) İstanbul tarihi, `YYYY-MM-DD`. */
export function istanbulToday(offsetDays = 0): string {
  return new Date(Date.now() + OFFSET_MS + offsetDays * DAY_MS).toISOString().slice(0, 10);
}

export function istanbulDisplayDate(iso: string): string {
  return new Date(iso).toLocaleDateString('tr-TR', { timeZone: 'Europe/Istanbul' });
}
